export const formatMinimumTwoDecimalPlaces = (value) => {
  if (value === null || value === undefined || value === "") return value ?? "";

  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return value;

  const raw = String(value).trim();
  const decimalMatch = raw.match(/^[+-]?(?:\d+)?(?:\.(\d*))?$/);
  const rawDecimals = decimalMatch?.[1]?.length || 0;
  const precision = Math.max(2, rawDecimals);

  let formatted = numeric.toFixed(precision);
  if (!formatted.includes(".")) return formatted;

  const [whole, decimal = ""] = formatted.split(".");
  let trimmed = decimal;
  while (trimmed.length > 2 && trimmed.endsWith("0")) {
    trimmed = trimmed.slice(0, -1);
  }

  return `${whole}.${trimmed.padEnd(2, "0")}`;
};


export const normalizeEditableDecimalForCommit = (value) => {
  if (value === null || value === undefined || value === "" || value === ".") return "";

  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : value;
};
